import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import RefundHistoryTable from "./Components/RefundHistoryTable";

/**
 * RefundHistoryList
 * Standalone page listing every refund ever processed, across all customers.
 */
const RefundHistoryList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Refund History</HeadingOne>
          <span
            className="badge fw-semibold px-3 py-2 d-flex align-items-center gap-2"
            style={{
              background: "#f8f9ff",
              color: "#667eea",
              border: "1px solid #c5cdf7",
              borderRadius: 20,
              fontSize: 13,
            }}
          >
            <i className="ti ti-history" />
            All refund records
          </span>
        </>
      }
    >
      <div className="col-12">
        <RefundHistoryTable />
      </div>
    </PageBody>
  );
};

export default RefundHistoryList;